<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1280px"
      title="丘成桐少年班、信息特长生初三年级"
      id-key="Junior9Id"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <table class="report-table no-border" border="1">
              <tr>
                <td colspan="25">
                  <div>
                    <span v-if="data.EnrollNo">报名序号：{{data.EnrollNo}}</span>
                    <span v-else>报名序号：(<span class="red">系统自动生成</span>)</span>
                  </div>
                  <div class="center large" style="margin:6px 0;">{{year}}年汕头市金山中学“丘成桐少年班”九年级学生报名信息表</div>
                  <div class="center large" style="margin:6px 0;">{{year}}年汕头市金山中学“信息学特长生”自主招生报名信息表</div>
                </td>
              </tr>
              <tr>
                <td class="center rq" style="width:13%;">姓名</td>
                <td class="center" colspan="4">
                  <el-input v-model="data.FullName" placeholder="请输入姓名" maxlength="10"></el-input>
                </td>
                <td class="center" colspan="2">性别</td>
                <td class="center" colspan="13">
                  <span v-if="data.Sex>0">{{data.Sex==1?"男":"女"}}</span>
                </td>
                <td class="center red bold small" rowspan="5" style="width:15%;">
                  <pic-upload v-if="!tbLoading" :data="{}" :ut="9" v-model="data.PicUrl" />
                </td>
              </tr>
              <tr>
                <td class="center rq">身份证号</td>
                <td class="center" colspan="4">
                  <el-input v-model="data.IdCard" @blur="getBirth()" placeholder="请输入身份证号" maxlength="20"></el-input>
                </td>
                <td class="center rq" colspan="2">户籍地</td>
                <td class="center" colspan="13">
                  <el-select v-model="data.Domicile" filterable allow-create class="red-inp" @blur="selectInp($event,'Domicile')" clearable maxlength="50" placeholder="请选择或准确输入户籍地">
                    <el-option v-for="item in hjd" :key="item.BaseDataId" :value="item.DataName" />
                  </el-select>
                </td>
              </tr>
              <tr>
                <td class="center rq">中考报名号(14位)</td>
                <td class="center" colspan="4">
                  <el-input v-model="data.MiddleExamNo" placeholder="请输入中考报名号" maxlength="14"></el-input>
                </td>
                <td class="center rq" colspan="2">就读学校所在区县</td>
                <td class="center" colspan="13">
                  <el-select v-model="data.SchoolDistrict" filterable allow-create class="red-inp" @blur="selectInp($event,'SchoolDistrict')" maxlength="20" clearable placeholder="请选择或准确输入区县">
                    <el-option v-for="item in xxssqx" :key="item.BaseDataId" :value="item.DataName" />
                  </el-select>
                </td>
              </tr>
              <tr>
                <td class="center rq">就读初中</td>
                <td class="center" colspan="19">
                  <el-select v-model="data.MiddleSchool" class="red-inp" filterable allow-create @blur="selectInp($event,'MiddleSchool')" clearable maxlength="20" placeholder="请选择或准确输入就读初中">
                    <el-option v-for="item in jdcz" :key="item.BaseDataId" :value="item.DataName" />
                  </el-select>
                </td>
              </tr>
              <tr>
                <td class="center rq">家长手机号码</td>
                <td class="center" colspan="19">
                  <el-input v-model="data.Mobile" class="red-inp" maxlength="11" v-int placeholder="报名时要用于接收手机验证码!"></el-input>
                </td>
              </tr>
              <tr>
                <td class="center rq" rowspan="2">报名类型</td>
                <td class="" colspan="24">
                  <el-checkbox v-model="data.EnrollInfo" @change="enrollInfoChange">信息学特长生</el-checkbox>
                  <div v-if="data.EnrollInfo" class="radio-box">
                    <el-radio-group v-model="enroll" @change="enrollChange">
                      <el-radio label="0" style="margin-bottom:0.5rem;">“专项测试、面试”模式（选择此模式不能兼报“丘班”）</el-radio><br/>
                      <div class="zm2" v-if="data.EnrollInfoTest">
                        <el-upload
                          action="/api/PoJunior9/UploadPictureInfo"
                          :show-file-list="true"
                          accept=".jpg,.png,.jpeg"
                          :on-success="(res,file,fileList) => { onSuccess(res,file,fileList,'InfoTestPicUrls') }"
                          :headers="headers"
                          :limit="4"
                          :file-list="InfoTestPicUrls"
                          :on-preview="handlePreview"
                          :on-exceed="onExceed"
                          :before-upload="beforePhotoUpload"
                          :on-remove="($event) => { picRemove($event,'InfoTestPicUrls') }">
                          <el-button type="primary">上传获奖证书图片</el-button>
                        </el-upload>
                      </div>
                      <el-radio label="1">“55方案”模式（选择此模式可以兼报“丘班”）</el-radio>
                    </el-radio-group>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="" colspan="24">
                  <el-checkbox v-model="data.EnrollQct" :disabled="enroll==='0'&&data.EnrollInfo">丘成桐少年班</el-checkbox>
                  <span style="margin-left:3rem;">（第一轮遴选为参加“55方案”的综合测试）</span>
                </td>
              </tr>
              <tr>
                <td class="center bold" colspan="25">
                  九年级成绩(本校初中毕业生人数，约
                  <el-input v-int v-model="data.StudentNumber" style="width:100px;"></el-input>
                  人)
                </td>
              </tr>
              <tr>
                <td class="center">考试</td>
                <td class="center grade">语文</td>
                <td class="center grade">数学</td>
                <td class="center grade">英语</td>
                <td class="center grade">物理</td>
                <td class="center grade">化学</td>
                <td class="center grade">政治</td>
                <td class="center grade">历史</td>
                <td class="center grade">总分</td>
                <td class="center red bold" colspan="16">综合成绩列年级(选填一项)</td>
              </tr>
              <tr>
                <td class="center rq">上学期期中</td>
                <td class="center"><el-input type="number" v-model="data.MidYw" @blur="checkPoint('MidYw')" /></td>
                <td class="center"><el-input type="number" v-model="data.MidSx" @blur="checkPoint('MidSx')" /></td>
                <td class="center"><el-input type="number" v-model="data.MidYy" @blur="checkPoint('MidYy')" /></td>
                <td class="center"><el-input type="number" v-model="data.MidWl" @blur="checkPoint('MidWl')" /></td>
                <td class="center"><el-input type="number" v-model="data.MidHx" @blur="checkPoint('MidHx')" /></td>
                <td class="center"><el-input type="number" v-model="data.MidZz" @blur="checkPoint('MidZz')" /></td>
                <td class="center"><el-input type="number" v-model="data.MidLs" @blur="checkPoint('MidLs')" /></td>
                <td class="center">{{total1}}</td>
                <td class="center" colspan="15">
                  <el-radio-group v-model="data.MidSn">
                    <el-radio :label="0">前5%</el-radio>
                    <el-radio :label="1">前30%</el-radio>
                    <el-radio :label="2">30%后</el-radio>
                  </el-radio-group>
                </td>
              </tr>
              <tr>
                <td class="center rq">上学期期末</td>
                <td class="center"><el-input type="number" v-model="data.FinalYw" @blur="checkPoint('FinalYw')" /></td>
                <td class="center"><el-input type="number" v-model="data.FinalSx" @blur="checkPoint('FinalSx')" /></td>
                <td class="center"><el-input type="number" v-model="data.FinalYy" @blur="checkPoint('FinalYy')" /></td>
                <td class="center"><el-input type="number" v-model="data.FinalWl" @blur="checkPoint('FinalWl')" /></td>
                <td class="center"><el-input type="number" v-model="data.FinalHx" @blur="checkPoint('FinalHx')" /></td>
                <td class="center"><el-input type="number" v-model="data.FinalZz" @blur="checkPoint('FinalZz')" /></td>
                <td class="center"><el-input type="number" v-model="data.FinalLs" @blur="checkPoint('FinalLs')" /></td>
                <td class="center">{{total2}}</td>
                <td class="center" colspan="15">
                  <el-radio-group v-model="data.FinalSn">
                    <el-radio :label="0">前5%</el-radio>
                    <el-radio :label="1">前30%</el-radio>
                    <el-radio :label="2">30%后</el-radio>
                  </el-radio-group>
                </td>
              </tr>
              <tr>
                <td class="center rq"><span class="bold">下学期区统考</span></td>
                <td class="center"><el-input type="number" v-model="data.UnifiedYw" @blur="checkPoint('UnifiedYw')" /></td>
                <td class="center"><el-input type="number" v-model="data.UnifiedSx" @blur="checkPoint('UnifiedSx')" /></td>
                <td class="center"><el-input type="number" v-model="data.UnifiedYy" @blur="checkPoint('UnifiedYy')" /></td>
                <td class="center"><el-input type="number" v-model="data.UnifiedWl" @blur="checkPoint('UnifiedWl')" /></td>
                <td class="center"><el-input type="number" v-model="data.UnifiedHx" @blur="checkPoint('UnifiedHx')" /></td>
                <td class="center"><el-input type="number" v-model="data.UnifiedZz" @blur="checkPoint('UnifiedZz')" /></td>
                <td class="center"><el-input type="number" v-model="data.UnifiedLs" @blur="checkPoint('UnifiedLs')" /></td>
                <td class="center">{{total3}}</td>
                <td class="center" colspan="15">
                  <el-radio-group v-model="data.UnifiedSn">
                    <el-radio :label="0">前5%</el-radio>
                    <el-radio :label="1">前30%</el-radio>
                    <el-radio :label="2">30%后</el-radio>
                  </el-radio-group>
                </td>
              </tr>
              <tr>
                <td class="center rq">综合素质<br />评价总得分<br />(选填一项)</td>
                <td class="center" colspan="24">
                  <el-radio-group v-model="data.QualityScore">
                    <el-radio :label="0">25分</el-radio>
                    <el-radio :label="1">24分</el-radio>
                    <el-radio :label="2">23分</el-radio>
                    <el-radio :label="3">≤22分</el-radio>
                  </el-radio-group>
                </td>
              </tr>
              <tr>
                <td class="center" rowspan="3">承诺：</td>
                <td class="center" colspan="24">
                  我们郑重承诺，以上所填内容完全真实准确。
                  <br />否则，愿意承担取消遴选资格或录取资格的后果。
                </td>
              </tr>
              <tr>
                <td class="center" colspan="2">家长签名：</td>
                <td class="center bold" colspan="23">
                  <el-image v-if="data.ParentSignUrl" :src="'/api'+data.ParentSignUrl" fit="contain" :preview-src-list="['/api'+data.ParentSignUrl]" style="height: 80px;width: 160px;" />
                  <span v-else>(确认提交本信息表后，默认家长和考生签名完成!)</span>
                </td>
              </tr>
              <tr>
                <td class="center" colspan="2">学生签名：</td>
                <td class="center" colspan="2">
                  <el-image v-if="data.StudentSignUrl" :src="'/api'+data.StudentSignUrl" fit="contain" :preview-src-list="['/api'+data.StudentSignUrl]" style="height: 80px;width: 160px;" />
                </td>
                <td class="center" colspan="21" v-if="data.AddTime">{{toYMString(data.AddTime)}}</td>
                <td class="center" colspan="21" v-else>{{year}}年{{month}}月</td>
              </tr>
              <tr>
                <td class="bold" colspan="25">
                  <span class="red">特别提示：</span>
                  <span class="blue">1、本表打印完成后，须在“电子彩照”位置贴上近期一寸彩照，并完成签名!!</span>
                  <div class="blue" style="text-indent:5rem;">2、本表于参加遴选时交给现场老师。</div>
                </td>
              </tr>
            </table>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <span class="statusText" v-if="data.Junior9Id">状态：{{statusText}}</span>
        <el-button type="primary" @click="toSave">保 存</el-button>
        <el-button type="primary" @click="submit" v-if="data.Status==0||data.Status==2">提 交</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <el-dialog :visible.sync="dialogVisible" title="查看图片">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
const date = new Date();
const year = date.getFullYear();
const month = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;

import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import picUpload from "../picUpload";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    picUpload,
  },
  data() {
    return {
      api: require("@/api/po/junior9").default,
      baseApi: require("@/api/po/basedata").default,
      data: {
        Junior9Id: 0,
        ParentId: 0,
        EnrollNo: "",
        FullName: "",
        Sex: null,
        IdCard: "",
        Domicile: "",
        MiddleExamNo: "",
        MiddleSchool: "",
        SchoolDistrict: "",
        Mobile: "",
        EnrollInfo: false,
        EnrollInfoTest: false,
        EnrollInfo55: false,
        EnrollQct: false,
        //------------
        StudentNumber: null,
        MidYw: null,
        MidSx: null,
        MidYy: null,
        MidWl: null,
        MidHx: null,
        MidZz: null,
        MidLs: null,
        MidSn: null,
        FinalYw: null,
        FinalSx: null,
        FinalYy: null,
        FinalWl: null,
        FinalHx: null,
        FinalZz: null,
        FinalLs: null,
        FinalSn: null,
        UnifiedYw: null,
        UnifiedSx: null,
        UnifiedYy: null,
        UnifiedWl: null,
        UnifiedHx: null,
        UnifiedZz: null,
        UnifiedLs: null,
        UnifiedSn: null,
        QualityScore: null,
        //------------
        PicUrl: "",
        ParentSignUrl: "",
        StudentSignUrl: "",
        InfoTestPicUrls: "",
        InfoTestPicNames: "",
        Status: 0,
        BirthDate: "",
        AddTime: "",
      },
      InfoTestPicUrls: [],
      dialogVisible: false,
      dialogImageUrl: "",
      headers: { Authorization: "" },
      tbLoading: true,
      enroll: null,
      setting: {
        EnableJunior9: true,
        Sign9StartDate: "",
        Sign9EndDate: "",
        Print9StartDate: "",
        Print9EndDate: "",
      },
      year,
      month,
      hjd: [],
      jdcz: [],
      xxssqx: [],
      isMB: this.$store.state.isMB,
      rules: {
        
      },
    };
  },
  computed: {
    statusText() {
      var result = "";
      switch (this.data.Status) {
        case 0:
          result = "待提交";
          break;
        case 1:
          result = "待审核";
          break;
        case 2:
          result = "审核未通过";
          break;
        case 3:
          result = "审核通过";
          break;
      }
      return result;
    },
    total1() {
      var total = 0;
      var e = this.data;
      total += Number(e.MidYw);
      total += Number(e.MidSx);
      total += Number(e.MidYy);
      total += Number(e.MidWl);
      total += Number(e.MidHx);
      total += Number(e.MidZz);
      total += Number(e.MidLs);
      return Math.floor(total * 10) / 10;
    },
    total2() {
      var total = 0;
      var e = this.data;
      total += Number(e.FinalYw);
      total += Number(e.FinalSx);
      total += Number(e.FinalYy);
      total += Number(e.FinalWl);
      total += Number(e.FinalHx);
      total += Number(e.FinalZz);
      total += Number(e.FinalLs);
      return Math.floor(total * 10) / 10;
    },
    total3() {
      var total = 0;
      var e = this.data;
      total += Number(e.UnifiedYw);
      total += Number(e.UnifiedSx);
      total += Number(e.UnifiedYy);
      total += Number(e.UnifiedWl);
      total += Number(e.UnifiedHx);
      total += Number(e.UnifiedZz);
      total += Number(e.UnifiedLs);
      return Math.floor(total * 10) / 10;
    },
  },
  methods: {
    onCreateOpened(data) {
      this.tbLoading = false;
      this.getBirth();
      this.getOption();
    },
    onEditOpened(data) {
      this.tbLoading = false;
      this.getOption();
      if(data.EnrollInfo) {
        this.enroll = data.EnrollInfoTest?"0":"1";
      } else this.enroll = null;
      var urlArr = ["InfoTestPicUrls"];
      var urlArr2 = ["InfoTestPicNames"];
      urlArr.forEach((e,index) => {
        if(data[e]) {
          var arr = data[e].split(",");
          var arr2 = data[urlArr2[index]].split(",");
          arr.forEach((n,i) => {
            this[e].push({ url: n, name: arr2[i] });
          })
        }
      });
    },
    getOption() {
      this.baseApi.list({ Status: 1 }).then(res => {
        if(res.Code==0) {
          this.hjd = res.Data.filter(x => x.ClassName == "户籍地");
          this.jdcz = res.Data.filter(x => x.ClassName == "就读初中");
          this.xxssqx = res.Data.filter(x => x.ClassName == "学校所属区县");
        } else this.$message.error(res.Msg);
      });
    },
    checkForm() {
      if(!this.data.FullName) {
        this.$message.error("请输入姓名");
        return false;
      }
      if(!this.data.Sex) {
        this.$message.error("请选择性别");
        return false;
      }
      if(!this.data.IdCard) {
        this.$message.error("请输入身份证号");
        return false;
      } else {
        let regex = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
        if(!regex.test(this.data.IdCard)) {
          this.$message.error("身份证格式不正确");
          return false;
        }
      }
      if(!this.data.Domicile) {
        this.$message.error("请输入户籍地");
        return false;
      }
      if(!this.data.MiddleExamNo) {
        this.$message.error("请输入中考报名号");
        return false;
      }
      if(!this.data.MiddleSchool) {
        this.$message.error("请输入就读初中");
        return false;
      }
      if(!this.data.SchoolDistrict) {
        this.$message.error("请输入就读初中所属区县");
        return false;
      }
      let regex2 = 11 && /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if(!regex2.test(this.data.Mobile)) {
        this.$message.error("请输入正确的家长手机号");
        return false;
      }
      if(!this.data.PicUrl) {
        this.$message.error("请上传照片");
        return false;
      }
      if(!this.data.EnrollInfo && !this.data.EnrollQct) {
        this.$message.error("请至少选择一个报名类型");
        return false;
      }
      if(this.data.EnrollInfo && this.enroll === null) {
        this.$message.error("请选择信息学特长生模式");
        return false;
      }
      if(!(this.data.StudentNumber > 0)) {
        this.$message.error("请输入有效的初中毕业生人数");
        return false;
      }
      var arr = [
        "MidSx","MidSx","MidYy","MidWl","MidHx","MidZz","MidLs",
        "FinalSx","FinalSx","FinalYy","FinalWl","FinalHx","FinalZz","FinalLs",
        "UnifiedSx","UnifiedSx","UnifiedYy","UnifiedWl","UnifiedHx","UnifiedZz","UnifiedLs"
      ];
      for (let i = 0; i < arr.length; i++) {
        const e = arr[i];
        if(this.data[e] === null || this.data[e] === "") {
          this.$message.error("请输入考试成绩");
          return false;
        }
      }
      var arr2 = ["MidSn","FinalSn","UnifiedSn"];
      for (let i = 0; i < arr2.length; i++) {
        const n = arr2[i];
        if(this.data[n] === null || this.data[n] < 0) {
          this.$message.error("请选择综合成绩列年级");
          return false;
        }
      }
      if(this.data.QualityScore === null || this.data.QualityScore < 0) {
        this.$message.error("请选择综合素质评价总得分");
        return false;
      } else if(this.data.EnrollInfo && this.data.QualityScore > 2) {
        this.$message.error('根据我校“信息学特长生”自主招生方案，要求报考学生的综合素质评价总得分不低于23分。请校对后重新保存。');
        return false;
      }
      var urlArr = ["InfoTestPicUrls"];
      var urlArr2 = ["InfoTestPicNames"];
      if(this.data.EnrollInfoTest) {
        var nameArr = ["获奖证书图片"];
        for (let i = 0; i < urlArr.length; i++) {
          var m = urlArr[i];
          if(this[m].length == 0) {
            this.$message.error("请上传"+nameArr[i]);
            return false;
          }
        }
      }
      urlArr.forEach((e,index) => {
        this.data[e] = "";
        this.data[urlArr2[index]] = "";
        this[e].forEach((n,i) => {
          this.data[e] += n.url;
          this.data[urlArr2[index]] += n.name;
          if(i < this[e].length - 1) {
            this.data[e] += ",";
          this.data[urlArr2[index]] += ",";
          }
        });
      })
      return true;
    },
    toSave() {
      if(!this.checkForm()) return false;
      this.loading(true);
      var sub = { ...this.data };
      delete sub.AddTime;
      this.api.save(sub).then(res => {
        this.loading(false);
        if(res.Code==0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.$emit('close-saved');
        } else this.$message.error(res.Msg);
      })
    },
    submit() {
      if(!this.checkForm()) return false;
      this.loading(true);
      var sub = { ...this.data };
      delete sub.AddTime;
      this.api.submit(sub).then(res => {
        this.loading(false);
        if(res.Code==0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.$emit('close-saved');
        } else this.$message.error(res.Msg);
      })
    },
    enrollChange(v) {
      if(v == "0") {
        this.data.EnrollInfoTest = true;
        this.data.EnrollInfo55 = false;
        this.data.EnrollQct = false;
      } else {
        this.data.EnrollInfoTest = false;
        this.data.EnrollInfo55 = true;
      }
    },
    enrollInfoChange(v) {
      if(v && this.enroll === "0") {
        this.data.EnrollQct = false;
      }
    },
    onBeforeSave() {
      return false;
    },
    toYMString(v) {
      if(!v) return "";
      var date = this.$commonJs.toDateString(v);
      var arr = date.split("/");
      return arr[0] + "年" + arr[1] + "月";
    },
    getBirth(idCard=this.data.IdCard) {
      let regex = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
      if(!regex.test(idCard)) {
        this.$message.error("身份证格式不正确");
      }
      var birthday = "";  
      if(idCard != null && idCard != "") {
          if(idCard.length == 15){  
              birthday = "19"+idCard.substr(6,6);  
          } else if(idCard.length == 18){  
              birthday = idCard.substr(6,8);  
          }
          birthday = birthday.replace(/(.{4})(.{2})/,"$1-$2-");  
          
          let genderCode; // 性别代码
          if (idCard.length == 18) { // 二代身份证号码长度为18位（第17位为性别代码）
              genderCode = idCard.charAt(16);
          } else if (idCard.length == 15) { // 一代身份证号码长度为15位（第15位为性别代码）
              genderCode = idCard.charAt(14);
          }
          if (genderCode && !isNaN(genderCode)) {
            // 两代身份证号码的性别代码都为男奇女偶
            if (parseInt(genderCode) % 2 == 0) {
              this.data.Sex = 2;
            } else this.data.Sex = 1;
          }
      }
      this.data.BirthDate = birthday||"";
    },
    beforePhotoUpload(file) {
      this.headers.Authorization = "Bearer " + localStorage.getItem("token");
      const is500k = file.size/1024 <= 500;
      if(!is500k) {
        this.$message.error("照片大小不能超过500k")
      }
      return is500k;
    },
    onSuccess(res,file,fileList,name) {
      if(res.Code==0) {
        this[name].push({ url: res.Data.VirtualPath, name: res.Data.FileName + "." + res.Data.Extension });
      } else {
        fileList.splice(fileList.length-1,1);
        this.$message.error(res.Msg);
      }
    },
    picRemove(file,name) {
      this[name].forEach((e,i) => {
        if(e.url == file.url) {
          this[name].splice(i,1);
          return;
        }
      })
    },
    handlePreview(file) {
      this.dialogImageUrl = "/api" + file.url;
      this.dialogVisible = true;
    },
    onExceed() {
      this.$message.error("只能上传四张图片");
    },
    checkPoint(name) {
      if(this.data[name]) {
        this.data[name] = Math.floor(this.data[name] * 10) / 10;
      }
    },
    selectInp(e,name) {
     let value = e.target.value;
      if(value) {
        this.data[name] = value
      }
    },
    onClosed() {
      this.InfoTestPicUrls = [];
      this.tbLoading = true;
      this.enroll = null;
      this.hjd = [];
      this.jdcz = [];
      this.xxssqx = [];
    },
  }
};
</script>
<style lang="scss">
.report-table {
  border-spacing: 0;
  border-collapse: collapse;
  width: 100%;
  font-size: 16px;
  td {
    padding: 6px 8px;
  }
  .el-input,.el-select {
    width: 100%;
  }
  .center {
    text-align: center;
  }
  .right {
    text-align: right;
  }
  .red {
    color: #f11;
  }
  .blue {
    color: #11f;
  }
  .small {
    font-size: 14px;
  }
  .large {
    font-size: 18px;
  }
  .el-checkbox__inner {
    width: 16px;
    height: 16px;
  }
  .el-checkbox__inner::after {
    height: 8px;
    left: 5px;
  }
  .el-checkbox__label {
    font-size: 16px;
    color: #000;
  }
  .red-inp {
    .el-input__inner::placeholder {
      color: #f11;
    }
  }
  .grade {
    width: 8%;
  }
  .radio-box {
    margin-left:3rem;
    display:inline-block;
    text-align:left;
    padding:0.2rem 0;
    .el-radio__label {
      font-size: 16px;
    }
  }
}
.statusText {
  color:#F11;
  float:left;
  font-weight: bold;
  line-height: 34px;
  margin-left: 8px;
  font-size: 16px;
}
.zm2 {
  font-size: 16px;
  margin-bottom: 15px;
}
.rq:before {content: '* ';color: red;}
</style>